import { coreUsersIdMapSlice } from './update';

export const updateUserReferences = coreUsersIdMapSlice.syncActionCreator;
